<script setup>
/** 世界频道发帖（/world/new）与修改（/world/:postId/edit、公会频道 /board/:postId/edit，`?reply=<回复 id>` 改的是回复）：只放表单。 */
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { Button, Textarea } from '@drama/ui'

import { api, currentGuild, getToken } from '../api.js'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const editing = typeof route.params.postId === 'string'
const target = typeof route.query.reply === 'string' ? route.query.reply : route.params.postId
const world = route.path.startsWith('/world')
const prefix = world ? '/world' : '/board'
const base = world ? '/api/voko/world/board' : `/api/voko/guilds/${encodeURIComponent(currentGuild.slug)}/board`
const draft = ref('')
const error = ref('')
const busy = ref(false)

onMounted(async () => {
  if (getToken() === null) {
    await router.push({ path: '/login', query: { next: route.fullPath } })
    return
  }
  if (!editing || currentGuild.slug === null && !world) return // 公会频道要等顶栏定下当前公会（页面随后按公会重建）
  const { post, replies } = await api('GET', `${base}/${encodeURIComponent(route.params.postId)}`)
  draft.value = [post, ...replies].find((item) => item.id === target).body
})

async function save() {
  busy.value = true
  error.value = ''
  try {
    if (editing) {
      await api('PATCH', `${base}/${encodeURIComponent(target)}`, { body: draft.value })
      await router.push(`${prefix}/${route.params.postId}`)
    } else {
      const { post } = await api('POST', base, { body: draft.value, parent_id: null })
      await router.push(`${prefix}/${post.id}`)
    }
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <header class="page-head">
    <div>
      <p class="page-head__eyebrow">AAJob</p>
      <h1 class="page-head__title">{{ editing ? t('channels.editTitle') : t('channels.newPost') }}</h1>
    </div>
    <router-link :to="editing ? `${prefix}/${route.params.postId}` : prefix">{{ t('guildBoard.back') }}</router-link>
  </header>
  <form class="voko-form" @submit.prevent="save">
    <Textarea v-model="draft" :rows="8" :maxlength="4000" :disabled="busy" :aria-label="t('channels.newPost')" :placeholder="t('channels.newPostHint')" />
    <p v-if="error" role="alert">{{ error }}</p>
    <Button type="submit" :disabled="busy || draft.trim() === ''">{{ editing ? t('channels.save') : t('channels.post') }}</Button>
  </form>
</template>

<style scoped>
.voko-form { display: grid; gap: var(--drama-space-md); }
</style>
